import { useMemo } from 'react';
import { toString } from 'lodash';

import useGetPreviewForLMNs from '@/modules/MyDocuments/hooks/useGetPreviewForLMNs';
import { extractFilenameFromS3Url } from '@/utils/handlers';
import { getFileType } from '@/utils/modifiers/getFileType';

import { LettersOfMedicalNecessity } from '../myDocuments.types';

interface Props {
  letterOfMedicalNecessities: LettersOfMedicalNecessity[];
}

const useGetLetterOfMedicalNecessitiesFiles = ({ letterOfMedicalNecessities }: Props) => {
  const { valuesMap, isLoading } = useGetPreviewForLMNs(letterOfMedicalNecessities);

  const letterOfMedicalNecessitiesFiles = useMemo(() => {
    if (!valuesMap) {
      return [];
    }

    const firstFiles = Object.values(valuesMap).map((item) => item.firstFile);

    const uniqFiles = [...new Set(firstFiles)];

    return uniqFiles?.map((file) => ({
      id: toString(file),
      path: file,
      url: file,
      type: getFileType(file) || '',
      preview: '',
      name: extractFilenameFromS3Url(file),
      temporalId: toString(file),
    }));
  }, [valuesMap]);

  return {
    letterOfMedicalNecessitiesFiles,
    isLetterOfMedicalNecessitiesFilesLoading: isLoading,
  };
};

export default useGetLetterOfMedicalNecessitiesFiles;
